import { isAfter, isBefore } from 'date-fns'

import { noticeController } from '@/controller/notice.controller'
import { RouteName } from '@/router'
import { envUtils } from '@/utils/envUtils'

class ServerMaintenanceService {
  static async checkServerMaintenance() {
    const { pathname } = window.location
    const isStagingOrLive = envUtils.isLive || envUtils.isStaging

    // 사전 확인이라 실패는 넘긴다. 실제 점검 중이면 5xx 응답 때 다시 확인된다
    const data = await this.fetchServerMaintenanceData().catch(() => null)
    if (!data) return

    const isServerMaintenancePeriod =
      !isBefore(new Date(), data.startDate) && !isAfter(new Date(), data.endDate)

    // 서버 점검 중일때는 점검중 페이지로 리다이렉트
    if (isServerMaintenancePeriod && pathname !== RouteName.serverMaintenance && isStagingOrLive) {
      window.location.href = RouteName.serverMaintenance
    }

    // 서버 점검 중이 아닌데 서버 점검 페이지 일땐 home으로 리다이렉트
    if (!isServerMaintenancePeriod && pathname === RouteName.serverMaintenance && isStagingOrLive) {
      window.location.href = RouteName.root
    }
  }

  static async fetchServerMaintenanceData() {
    return await noticeController.fetchServerMaintenanceNotice()
  }
}

export default ServerMaintenanceService
